import { Select } from "./Select";
import { Tag } from "../../Tag";
import { toMap } from "../../../../../HA";

export class HAFile extends Select {

    public getType() {
        return "MultiText";
    }

    public getChoices() {
        const r = new Map();
        const choices = this.getSelected();

        if (choices) {
            choices.forEach((c: any) => {
                if (c instanceof Tag) {
                    r.set(r.size, toMap({item: c, s: this.isSelected(c)}));
                    return;
                }
                r.set(c, toMap({v: c, s: this.isSelected(c)}));
            });
        }

        return r;
    }

    protected getChoicesLength() {
        return 0;
    }

    protected isSelected(value: any) {
        return true;
    }
}
